jQuery(function ($) {
    'use strict';

    const selectors = {
        siteSelector     : '.js-location-modal',
        popupBtn         : '.modal-button',
        closeBtn         : '.js-close-modal-button',
        modal            : '.modal',
        overlay          : '.modal-overlay',
        locationSelection: '.js-location-selection',
        body             : 'body'
    };

    if (!readCookie('location_selected')) {
        const accessKey = '1ef293feba7c9721ecf942a287c7356e';
        const shopUrl   = $('.js-location-modal').attr('data-shopurl');

        $.ajax({
            url     : '//api.ipstack.com/check?access_key=' + accessKey,
            dataType: 'jsonp',
            success : $.proxy(function (location) {
                if (location.country_code === 'CA' && shopUrl === 'pulpandpress-usa.myshopify.com') {
                    showLocationModal();
                }

                if (location.country_code === 'US' && shopUrl === 'pulpandpress.myshopify.com') {
                    showLocationModal();
                }
            }, this)
        });
    }

    $(selectors.locationSelection).on('click', function (e) {
        createCookie('location_selected', 1, 60);
    });

    function showLocationModal() {
        if (selectors.siteSelector.length > 0) {
            $(selectors.overlay).first()
                                .fadeIn();

            $(selectors.siteSelector).first()
                                     .fadeIn();

            $(selectors.body).addClass('popup-modal-active');
        }
    }

    $(selectors.overlay + ',' + selectors.closeBtn).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(selectors.modal).fadeOut();
        $('.modal-window').hide();
    });

    /**
     *
     * @param name
     * @param value
     * @param days
     */
    function createCookie(name, value, days) {
        var expires = '';

        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }

        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    /**
     *
     * @param name
     * @returns {string|null}
     */
    function readCookie(name) {
        const nameEQ = name + '=',
              ca     = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return null;
    }
});
